export default __webpack_public_path__ + "static/media/homeimg.0be22bd3.gif";